<template>
  <div>
    <a-form class="simiot-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="8" :xxl="6">
          <a-form-item label="模组厂商">
            <a-select
              v-decorator="['module_producer_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingProducerOptions"
              @change="handleProducerChange"
            >
              <a-select-option
                v-for="opt in producerOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="模组型号">
            <a-select
              v-decorator="['module_model_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请先选择模组厂商"
              :loading="loadingModelOptions"
            >
              <a-select-option
                v-for="opt in modelOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item :wrapper-col="{ span: 24 }">
            <a-button type="primary" html-type="submit">搜索</a-button>
            <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { findCommonTypeOptions } from '@/api/common_type'

export default {
  name: 'SearchModuleInventoryStatistic',
  data() {
    return {
      form: this.$form.createForm(this),
      producerOptions: [],
      modelOptions: [],
      loadingProducerOptions: false,
      loadingModelOptions: false
    }
  },
  created() {
    this.fetchProducerOptions()
  },
  methods: {
    fetchProducerOptions() {
      this.loadingProducerOptions = true
      findCommonTypeOptions('product_module_producer').then((res) => {
        if (res.code === 0) {
          this.producerOptions = res.data || []
        }
        this.loadingProducerOptions = false
      })
    },

    fetchModelOptions(producerId) {
      this.modelOptions = []
      if (!producerId) {
        return
      }
      this.loadingModelOptions = true
      findCommonTypeOptions('product_module_model', undefined, producerId).then((res) => {
        if (res.code === 0) {
          this.modelOptions = res.data || []
        }
        this.loadingModelOptions = false
      })
    },

    handleProducerChange(producerId) {
      this.form.setFieldsValue({ module_model_id: undefined })
      this.fetchModelOptions(producerId)
    },

    handleSearch(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$emit('submit', values)
        }
      })
    },

    handleReset() {
      this.form.resetFields()
      this.modelOptions = []
      this.$emit('submit', {})
    }
  }
}
</script>
